import { httpSetup } from './http-client-setup';

httpSetup();
